import styled, { css } from "styled-components";

export const StyledImageWrapper = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   height: 100%;
   ${({ maxWidth }) => maxWidth && css`
      max-width: ${maxWidth};
   `};
`;

export const StyledImage = styled.img`
   max-width: 100%;
   ${({ maxHeight }) => maxHeight && css`
      max-height: ${maxHeight};
   `};
`;